import { type QueryKey, skipToken, type UseQueryOptions, type UseSuspenseQueryOptions } from "@tanstack/react-query";

export const suspenseQuery = <TQueryFnData, TError, TData, TQueryKey extends QueryKey>({
  queryFn,
  ...options
}: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>): UseSuspenseQueryOptions<
  TQueryFnData,
  TError,
  TData,
  TQueryKey
> => ({ ...options, queryFn: queryFn === skipToken ? undefined : queryFn });
